// @flow
import React from 'react';
import type { Element, ChildrenArray } from 'react';
import {
  types as t,
  usePropsValidation,
} from '../validation/runtime-checks/index.js';
import color from '../color.js';
import bullet from './bullet.svg';
import { Heading } from '../Heading.js';
import { Language, English, Spanish } from '../languages.js';
import { Text } from '../Text.js';

import { Children } from 'react';

export function SSOEssentialQuestionsList(props: {|
  children: ChildrenArray<Element<typeof SSOEssentialQuestion>>,
|}) {
  const { failedValidation } = usePropsValidation(
    props,
    SSOEssentialQuestionsList,
  );
  if (failedValidation) return null;

  const plural = Children.count(props.children) > 1;
  return (
    <>
      <Heading>
        <Language>
          <English>Essential question{plural && 's'}</English>
          <Spanish>
            {plural ? 'Preguntas esenciales' : 'Pregunta esencial'}
          </Spanish>
        </Language>
      </Heading>
      {plural ? (
        <ul style={{ padding: 16 }}>
          {Children.map(props.children, (item, i) => (
            <li
              key={i}
              style={{
                color: color.shuttleGray,
                listStyleImage: `url(${bullet})`,
                listStylePosition: 'outside',
              }}
            >
              {item}
            </li>
          ))}
        </ul>
      ) : (
        props.children
      )}
    </>
  );
}

SSOEssentialQuestionsList.spec = {
  children: t.minimumCount(1, t.elementType(SSOEssentialQuestion)),
};

export function SSOEssentialQuestion(props: {|
  children: Element<typeof Text>,
|}) {
  const { failedValidation } = usePropsValidation(props, SSOEssentialQuestion);

  if (failedValidation) return null;

  return props.children;
}

SSOEssentialQuestion.spec = { children: t.elementType(Text) };
